import { ACTIVITIES_TILES } from "../../content/activities";
import { langFromPath } from "../../i18n/lang";
import { Page } from "../../layout/Page";
import { Reveal } from "../../ui/Reveal";
import { Section } from "../../ui/Section";
import { Tile } from "../../ui/Tile";

/**
 * The old site's `/activities` (and `/activities-HI`): four tiles to the
 * daily practice, weekly session, Swarved Akhand Path and Gita Jayanti
 * sub-pages, verbatim titles and sub-labels from the old carousel.
 */
export function ActivitiesPage() {
  const { lang } = langFromPath(window.location.pathname);

  return (
    <Page title="Activities" heading="Activities">
      <Section>
        <div className="grid gap-6 sm:grid-cols-2">
          {ACTIVITIES_TILES.map((tile) => (
            <Reveal key={tile.href}>
              <Tile
                tone={tile.tone}
                title={tile.title[lang]}
                sub={tile.sub[lang]}
                href={tile.href}
              />
            </Reveal>
          ))}
        </div>
      </Section>
    </Page>
  );
}
